<template>
   <v-btn
      class="ma-2"
      :color="color"
      dark
      :loading="loading"
      elevation="5"
      :fab="isFab"
      @click="method"
      >{{ name }}
      <v-icon dark :right="isIconRight" v-if="nameIcon">{{
         `fas fa-${nameIcon}`
      }}</v-icon>
   </v-btn>
</template>

<script>
export default {
   props: {
      method: {
         type: Function,
         default: () => {
            return
         }
      },
      color: { type: String },
      name: { type: String },
      nameIcon: { type: String },
      loading: { type: Boolean },
      isFab: { type: Boolean },
      isIconRight: { type: Boolean }
   }
}
</script>
